import React, { useMemo } from 'react';
import { TableInstance } from 'react-table';

import { NumberCell } from '@work4all/components';
import { useTableVariant } from '@work4all/components/lib/components/table/TableVariantProvider';

import { Position } from '@work4all/models/lib/Classes/Position.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { convertEntityToBzObjType } from '@work4all/models/lib/utils/convertEntityToBzObjType';

import { EntityTable, IEntityTable } from '../../entity-table/EntityTable';
import { useEntityDataTable } from '../../entity-table/use-entity-data-table';

import { useErpHeader } from './ErpPageHeader';
import { useErpPositionSchema } from './use-erp-position-schema';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ErpPositionsTableProps {}

const defaultSort = [
  { field: 'details.bz_Date', direction: SortDirection.DESCENDING },
  { field: 'details.bz_Number', direction: SortDirection.DESCENDING },
];

export const ErpPositionsTable = React.forwardRef<TableInstance, IEntityTable>(
  (props: ErpPositionsTableProps, ref) => {
    const { variant } = useTableVariant();
    const parentEntity = variant as Entities;
    const editedSchema = useErpPositionSchema(parentEntity);
    const vars = useMemo(() => {
      return {
        bzObjType: convertEntityToBzObjType(parentEntity),
      };
    }, [parentEntity]);

    const dataTable = useEntityDataTable<Position, never>({
      schema: editedSchema as never,
      defaultSort,
      vars,
      cells: {
        Number: NumberCell,
      },
    });

    useErpHeader(parentEntity, 'positions');
    return (
      <EntityTable
        ref={ref}
        {...dataTable}
        onRowDoubleClick={() => true}
        actions={{
          add: undefined,
          edit: undefined,
          remove: undefined,
        }}
        overrides={{ areas: {} }}
      />
    );
  }
);
